import { render, staticRenderFns } from "./EditLabelRemark.vue?vue&type=template&id=78893b84&scoped=true&"
import script from "./EditLabelRemark.vue?vue&type=script&lang=js&"
export * from "./EditLabelRemark.vue?vue&type=script&lang=js&"
import style0 from "./EditLabelRemark.vue?vue&type=style&index=0&id=78893b84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78893b84",
  null
  
)

export default component.exports